var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { SubmissionPeriodFiles } from "./../models/V1/SubmissionPeriods/SubmissionPeriodFiles";
import { SearchResult } from "./../models/V1/SubmissionPeriods/Search/SearchResult";
import { BatchUploadResult } from "./../models/V1/SubmissionPeriods/BatchUploadResult";
export class SubmissionPeriods {
  /**
   * Creates an instance of SubmissionPeriods.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof SubmissionPeriods
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param ChangePaymentStatusRq_ _changePaymentStatusRq
   * @returns Promise<ChangePaymentStatusRq_>
   * @memberof SubmissionPeriods
   */
  changePaymentStatus(pChangePaymentStatusRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/paymentstatus",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pChangePaymentStatusRq.submissionPeriodId, required: true }]);
    client.addBody({ value: pChangePaymentStatusRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeRevisionRq_ _changeRevisionRq
   * @returns Promise<ChangeRevisionRq_>
   * @memberof SubmissionPeriods
   */
  changeRevision(pChangeRevisionRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/revision",
      "PATCH",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pChangeRevisionRq.submissionPeriodId, required: true }]);
    client.addBody({ value: pChangeRevisionRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeStatusRq_ _changeStatusRq
   * @returns Promise<ChangeStatusRq_>
   * @memberof SubmissionPeriods
   */
  changeStatus(pChangeStatusRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/status",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pChangeStatusRq.submissionPeriodId, required: true }]);
    client.addBody({ value: pChangeStatusRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 204 },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadDocumentRq_ _downloadDocumentRq
   * @returns Promise<DownloadDocumentRq_>
   * @memberof SubmissionPeriods
   */
  downloadDocument(pDownloadDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/Documents/{type}/{documentId}",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addPathParams([
      { name: "submissionPeriodId", value: pDownloadDocumentRq.submissionPeriodId, required: true },
      { name: "documentId", value: pDownloadDocumentRq.documentId, required: true },
      { name: "type", value: pDownloadDocumentRq.type, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadSubmissionsReturnFilesRq_ _downloadSubmissionsReturnFilesRq
   * @returns Promise<DownloadSubmissionsReturnFilesRq_>
   * @memberof SubmissionPeriods
   */
  downloadSubmissionsReturnFiles(pDownloadSubmissionsReturnFilesRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/SubmissionPeriods/returnfiles", "POST", "application/json; charset=UTF-8", "application/zip", options);
    client.addBody({ value: pDownloadSubmissionsReturnFilesRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ExportRq_ _exportRq
   * @returns Promise<ExportRq_>
   * @memberof SubmissionPeriods
   */
  export(pExportRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/SubmissionPeriods/export", "POST", "application/json; charset=UTF-8", "text/csv, application/json", options);
    client.addBody({ value: pExportRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 403, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetFilesRq_ _getFilesRq
   * @returns Promise<GetFilesRq_>
   * @memberof SubmissionPeriods
   */
  getFiles(pGetFilesRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/files",
      "GET",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pGetFilesRq.submissionPeriodId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: SubmissionPeriodFiles },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param HideSubmissionProofRq_ _hideSubmissionProofRq
   * @returns Promise<HideSubmissionProofRq_>
   * @memberof SubmissionPeriods
   */
  hideSubmissionProof(pHideSubmissionProofRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/submissionproofs/{referenceId}/hide",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "submissionPeriodId", value: pHideSubmissionProofRq.submissionPeriodId, required: true },
      { name: "referenceId", value: pHideSubmissionProofRq.referenceId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchRq_ _searchRq
   * @returns Promise<SearchRq_>
   * @memberof SubmissionPeriods
   */
  search(pSearchRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/SubmissionPeriods/search", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pSearchRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: SearchResult },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 403, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateIgnoreWarningsRq_ _updateIgnoreWarningsRq
   * @returns Promise<UpdateIgnoreWarningsRq_>
   * @memberof SubmissionPeriods
   */
  updateIgnoreWarnings(pUpdateIgnoreWarningsRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/ignorewarnings",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pUpdateIgnoreWarningsRq.submissionPeriodId, required: true }]);
    client.addBody({ value: pUpdateIgnoreWarningsRq.body, isPrimitive: true });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadNotToBeSubmittedProofRq_ _uploadNotToBeSubmittedProofRq
   * @returns Promise<UploadNotToBeSubmittedProofRq_>
   * @memberof SubmissionPeriods
   */
  uploadNotToBeSubmittedProof(pUploadNotToBeSubmittedProofRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/documents/nottobesubmittedproof",
      "POST",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pUploadNotToBeSubmittedProofRq.submissionPeriodId, required: true }]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadNotToBeSubmittedProofRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadPaymentProofRq_ _uploadPaymentProofRq
   * @returns Promise<UploadPaymentProofRq_>
   * @memberof SubmissionPeriods
   */
  uploadPaymentProof(pUploadPaymentProofRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/documents/paymentproof",
      "POST",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pUploadPaymentProofRq.submissionPeriodId, required: true }]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadPaymentProofRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadProofsRq_ _uploadProofsRq
   * @returns Promise<UploadProofsRq_>
   * @memberof SubmissionPeriods
   */
  uploadProofs(pUploadProofsRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/SubmissionPeriods/documents/proofs", "POST", "multipart/form-data", "text/plain, application/json, text/json", options);
    client.addFormData("multipart/form-data", [{ name: "files", value: pUploadProofsRq.files }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: BatchUploadResult, isArray: true },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadReturnDocumentsRq_ _uploadReturnDocumentsRq
   * @returns Promise<UploadReturnDocumentsRq_>
   * @memberof SubmissionPeriods
   */
  uploadReturnDocuments(pUploadReturnDocumentsRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/documents/return",
      "POST",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pUploadReturnDocumentsRq.submissionPeriodId, required: true }]);
    client.addFormData("multipart/form-data", [{ name: "files", value: pUploadReturnDocumentsRq.files }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadSubmissionProofRq_ _uploadSubmissionProofRq
   * @returns Promise<UploadSubmissionProofRq_>
   * @memberof SubmissionPeriods
   */
  uploadSubmissionProof(pUploadSubmissionProofRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionPeriods/{submissionPeriodId}/documents/submissionproof",
      "POST",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pUploadSubmissionProofRq.submissionPeriodId, required: true }]);
    client.addFormData("multipart/form-data", [{ name: "files", value: pUploadSubmissionProofRq.files }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
export var DownloadDocumentType = /* @__PURE__ */ ((DownloadDocumentType2) => {
  DownloadDocumentType2["SubmissionProof"] = "SubmissionProof";
  DownloadDocumentType2["PaymentProof"] = "PaymentProof";
  DownloadDocumentType2["NotToBeSubmittedProof"] = "NotToBeSubmittedProof";
  DownloadDocumentType2["Return"] = "Return";
  DownloadDocumentType2["DataVat"] = "DataVat";
  DownloadDocumentType2["Transaction"] = "Transaction";
  DownloadDocumentType2["InvalidVatNumbersReport"] = "InvalidVatNumbersReport";
  DownloadDocumentType2["OutOfScopeFile"] = "OutOfScopeFile";
  DownloadDocumentType2["RefusedReasonFile"] = "RefusedReasonFile";
  DownloadDocumentType2["RecoverPercentageExceptionListFile"] = "RecoverPercentageExceptionListFile";
  DownloadDocumentType2["SubmissionErrorFile"] = "SubmissionErrorFile";
  return DownloadDocumentType2;
})(DownloadDocumentType || {});
